export default "__VITE_ASSET__CEsRBaH5__"